import React, { useEffect, useRef } from "react";
import { twMerge } from "tailwind-merge";

export interface ContainerProps {
  children?: React.ReactNode;
  className?: string;
  tabIndex?: number;
  id?: string;
}

export const Container: React.FC<ContainerProps> = ({
  children,
  className,
  tabIndex,
  id,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    ref.current?.focus();
  }, [id]);

  return (
    <div
      ref={ref}
      className={twMerge(
        "p-6 border border-chariot-stroke rounded-md focus:outline-none",
        className
      )}
      tabIndex={tabIndex}
    >
      {children}
    </div>
  );
};
